import { AnalyticsEvent } from "@common/constants/analytics-events";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { UpgradeCta } from "@components/settings/Plans/UpgradeCta";
import { useEffectOnce } from "@hooks/useEffectOnce";
import { trackEvent } from "@lib/analytics";

export const ReconciliationPaywalled = () => {
    useEffectOnce(() => {
        void trackEvent(AnalyticsEvent.UPSELL_RECONCILIATION_ATTEMPTED);
    });

    return (
        <div className="flex flex-col w-inherit">
            <UpgradeCta
                title={
                    <>
                        Reconciliation is available on the{" "}
                        <span className="text-blue-600">Basic</span> plan
                    </>
                }
                subtitle="Match bank statements against your books and keep account balances accurate."
                plan={FLAT_RATE_PLANS.BASIC}
            />
            <img
                src="/images/features/reconciliation.png"
                alt="Premium feature preview"
                width="100%"
            />
        </div>
    );
};
